<p-confirmDialog></p-confirmDialog>
<div id="donor-flags" data-cy="donor-flags">
    <h1>Donor Flags</h1>
    <p-card>
        <!-- [classes]="['absolute mt-3']" -->
        <rc-generic-button 
            level="secondary"
            size="large"
            label="Add New Flag"
            [classes]="['mt-2 mb-4']"
            (clickHandler)="onAddNewFlag()"
            data-cy="btn-add-new-flag"
            />
            
        <rc-generic-table 
            exportLabel="Donor Flags"
            [columns]="columns"
            [rows]="rows"
            (actionClicked)="onActionClicked($event)"
            data-cy="table-data"/>
    </p-card>
</div>

<!-- Add/Edit Donor Flag modal -->
<p-dialog [(visible)]="showAddEditDialog"
    [modal]="true"
    header="{{ isEditMode ? 'Edit Donor Flag' : 'Add Donor Flag' }}"
    styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

    <ng-container>
        <form [formGroup]="addEditDonorFlag">
            <div class="formgrid grid">
                <div class="field col-12">
                    <label for="name" class="field-label required">Flag Name</label>
                    <input id="name" pInputText formControlName="name" placeholder="" data-cy="input-name" />    
                    <div *ngIf="addEditDonorFlag.get('name')?.invalid && addEditDonorFlag.get('name')?.touched" class="block p-error">
                        <small id="name-error" class="error">
                            Please enter Donor flag name.
                        </small>
                    </div>
                </div>
                <div class="field col-12">
                    <label for="description" class="field-label required">Flag Description</label>
                    <textarea id="description" pInputText formControlName="description" placeholder="" data-cy="input-description">
                    </textarea>
                    <div *ngIf="addEditDonorFlag.get('description')?.invalid && addEditDonorFlag.get('description')?.touched" class="block p-error">
                        <small id="description-error" class="error">
                            Please enter Donor flag description.
                        </small>
                    </div>
                </div>
                <div class="field col-12" data-cy="btn-toggle">
                    <p-toggleButton name="status" onLabel="Active" offLabel="Inactive" onIcon="pi pi-check-circle"
                        offIcon="pi pi-ban" formControlName="status" />
                </div>
            </div>
        </form>
    </ng-container>   

    <ng-template pTemplate="footer">
        <rc-generic-button label="Cancel" borderStyle="text-only" (click)="onCloseAddEditDialog()" data-cy="btn-cancel"/>
        <rc-generic-button label="Save" (click)="onSaveDonorFlag()" data-cy="btn-save" />
    </ng-template>
</p-dialog>
